import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterReminderCreatedBy,
  TAdvancedFilterSingle,
  TFilterReminderCreatedByOptions,
} from '../../../../models/advanced-filter.model';
import { getAdvancedReminderCreatedByOptions } from './get-advanced-filter-reminder-created-by-options';

@Component({
    selector: 'pp-advanced-filter-reminder-created-by',
    templateUrl: './advanced-filter-reminder-created-by.component.html',
    styleUrl: './advanced-filter-reminder-created-by.component.scss',
    standalone: false
})
export class AdvancedFilterReminderCreatedByComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  option: TFilterReminderCreatedByOptions;
  filter: TAdvancedFilterReminderCreatedBy;

  advancedFilterReminderCreatedByOptions = getAdvancedReminderCreatedByOptions();
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterReminderCreatedBy;

    this.option = this.filter.option;
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter.option = newCondition.value as TFilterReminderCreatedByOptions;
    this.option = newCondition.value as TFilterReminderCreatedByOptions;
    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }
}
